import { KeyboardDatePicker } from "@material-ui/pickers";
import { format, isValid } from "date-fns";

export default function FilterDate({
  label,
  name,
  value,
  onChange,
  width = 180,
}) {
  const inputId = `${name}-input`;

  const handleDateChange = (date) => {
    if (isValid(date)) {
      const formatted = format(date, "MM/dd/yyyy");
      onChange(name, formatted);
    }
  };

  return (
    <KeyboardDatePicker
      autoOk
      disableToolbar
      variant="inline"
      inputVariant="outlined"
      format="MM/dd/yyyy"
      label={label}
      id={inputId} // This sets the id on the <input>
      value={value || null}
      onChange={handleDateChange}
      style={{ width, minWidth: width, flexGrow: 1 }}
      InputLabelProps={{ shrink: true }}
      KeyboardButtonProps={{ "aria-label": "change date" }}
    />
  );
}
